import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { Paso1pagePageRoutingModule } from './paso1page-routing.module';
import { CalendarModule } from 'ion2-calendar';
import { IonicSelectableModule } from 'ionic-selectable';
import {MiscomponentesModule} from '../miscomponentes/componentes.module'

import { Paso1pagePage } from './paso1page.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    Paso1pagePageRoutingModule,
    CalendarModule,
    IonicSelectableModule,
    MiscomponentesModule
  ],
  declarations: [
    Paso1pagePage,
    
  ]
})
export class Paso1pagePageModule {}
